














import {Component, Prop, Vue, Answer, ComponentStyle, ComponentStyleDefinition, VueComponent, InjectComponent} from "@zoovu/runner-browser-api";

@Component({})
export default class CheckboxAnswerView extends Vue {

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @Prop()
    answerTextHeight: string;

    @Prop()
    imageHeight: string;

    @Prop()
    answer: Answer;

    @Prop()
    isFirstAnswer: boolean;

    @Prop()
    isLastAnswer: boolean;

    get componentStateClasses() {
        return {
            'is-first-answer': this.isFirstAnswer,
            'is-last-answer': this.isLastAnswer,
        };
    }

    @InjectComponent("ChoiceAnswerView")
    choiceAnswer: VueComponent;

    selectAnswer(): void {
        if ((this.answer.question == null || !this.answer.question.readOnly) && !this.answer.disabled) {
            this.answer.toggleSelection();
        }
    }
}
